import React from 'react';
import { precoProdutoVigente, numeroPreco } from '../../Utils/promocao';
import { precoCatalogoProduto } from '../../Utils/catalogoPreco';
import './PrecoProduto.css';

// Projeção visual: mantém o preço cadastrado intacto para edição e salvamento.
export default function PrecoProduto({ produto, moeda = false, considerarComplementos = false }: {
  produto: any; moeda?: boolean; considerarComplementos?: boolean;
}) {
  const normal = numeroPreco(produto.valorNormalPromocao ?? produto.valor);
  const atual = numeroPreco(precoProdutoVigente(produto));
  const desconto = Number.isFinite(normal) && Number.isFinite(atual) && atual >= 0 && atual < normal;
  const formatar = (valor: number) => valor.toLocaleString('pt-BR', {
    style: 'currency', currency: 'BRL',
  });

  if (considerarComplementos && !desconto && atual === 0 && produto.tipo !== 'pizzas') {
    const inicial = precoCatalogoProduto({ ...produto, valor: atual });
    if (inicial) return <>A partir de {moeda ? formatar(inicial.valor) : inicial.valor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2,
    })}</>;
  }

  if (!desconto) return <>{Number.isFinite(normal) ? moeda ? formatar(normal) : normal.toLocaleString('pt-BR', {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }) : '—'}</>;

  return <span className="produto-preco-offer">
    <span className="produto-preco-current">{formatar(atual)}</span>
    <span className="produto-preco-discount-detail">
      <del aria-label={`Preço original: ${formatar(normal)}`}>{formatar(normal)}</del>
      <span className="produto-preco-discount">-{Math.round((1 - atual / normal) * 100)}%</span>
    </span>
  </span>;
}
